"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var setup = function setup() {
  return {
    description: 'Add an RPA activity template.',
    flows: [{
      label: 'Upload an RPA activity template',
      fields: [{
        name: 'mainFile',
        inputType: 'file',
        classifier: 'rpa-activity-template',
        extensions: ['.calw'],
        required: true,
        hasMainFile: true,
        mainFileProperty: 'mainFile'
      }]
    }]
  };
};
var _default = exports.default = setup;
//# sourceMappingURL=form.js.map